// extracted by mini-css-extract-plugin
module.exports = {"container":"SrcSet_container__KMbkC","image":"SrcSet_image__rG3R4"};